import { mapProductPrice, RawProductPrice } from '~/Api/Product';
import Price from '~/utils/Price/Price';

import { ProductComputedPrice } from './ProductComputedPrice';
import { ReferencePrice } from './ReferencePrice';

interface RawCalculatedPrice {
	readonly currency: string;
	readonly description: string;
	readonly selected: boolean;
	readonly type: string;
	readonly value: string;
}

export interface RawReferencePrice {
	readonly sourcePrice: RawProductPrice;
	readonly calculatedPrice: RawCalculatedPrice;
}

export const mapReferencePrice = (referencePrice: RawReferencePrice) =>
	new ReferencePrice(
		mapProductPrice(referencePrice.sourcePrice),
		new ProductComputedPrice(
			referencePrice.calculatedPrice.type,
			new Price(referencePrice.calculatedPrice.value, referencePrice.calculatedPrice.currency),
			referencePrice.calculatedPrice.description,
			referencePrice.calculatedPrice.selected
		)
	);
